import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@material-ui/core';

import useStyles from './useStyles';

const DesktopCalculationsResult = props => {
  const { homePrice, downPayment, mortgagePayment, totalDebtPayments, debtToIncome } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box my={4} width="100%">
      <Box display="flex">
        <Typography variant="h2" className={classes.text}>
          {`${t('components.AffordabilityCalculator.DesktopCalculationsResult.homeValue')}: ${homePrice}`}
        </Typography>
      </Box>
      <Box display="flex" mt={3}>
        <Box height={55} width={150} display="flex" flexDirection="column" justifyContent="space-between">
          <Typography variant="subtitle1">
            {t('components.AffordabilityCalculator.DesktopCalculationsResult.downPayment')}
          </Typography>
          <Typography variant="h1">{downPayment}</Typography>
        </Box>
        <Box height={55} width={150} display="flex" flexDirection="column" justifyContent="space-between" ml={5}>
          <Typography variant="subtitle1">
            {t('components.AffordabilityCalculator.DesktopCalculationsResult.mortgagePayment')}
          </Typography>
          <Typography variant="h1">{mortgagePayment}</Typography>
        </Box>
        <Box height={55} width={150} display="flex" flexDirection="column" justifyContent="space-between" ml={5}>
          <Typography variant="subtitle1">
            {t('components.AffordabilityCalculator.DesktopCalculationsResult.totalDebtPayments')}
          </Typography>
          <Typography variant="h1">{totalDebtPayments}</Typography>
        </Box>
        <Box height={55} width={150} display="flex" flexDirection="column" justifyContent="space-between" ml={5}>
          <Typography variant="subtitle1">
            {t('components.AffordabilityCalculator.DesktopCalculationsResult.debtToIncome')}
          </Typography>
          <Typography variant="h1">{debtToIncome}</Typography>
        </Box>
      </Box>
      <Box width="100%" className={classes.divider} />
    </Box>
  );
};

DesktopCalculationsResult.propTypes = {
  homePrice: PropTypes.string.isRequired,
  downPayment: PropTypes.string.isRequired,
  mortgagePayment: PropTypes.string.isRequired,
  totalDebtPayments: PropTypes.string.isRequired,
  debtToIncome: PropTypes.string.isRequired,
};

export default DesktopCalculationsResult;



// WEBPACK FOOTER //
// ./src/sharedComponents/AffordabilityCalculator/components/DesktopCalculationsResult/DesktopCalculationsResult.js